import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';

const container = document.getElementById('root');
if (!container) throw new Error('root element not found');

ReactDOM.createRoot(container).render(
  <RecoilRoot>
    <BrowserRouter basename="/">
      <App />
    </BrowserRouter>
  </RecoilRoot>,
);
